import { Switch } from '@headlessui/react'

interface Props {
    label: string
    checked: boolean
    onChange: (checked: boolean) => void
}

export const ToggleSwitch = ({ label, checked, onChange }: Props) => {
    return (
        <Switch.Group as="div" className="flex items-center">
            <Switch
                checked={checked}
                onChange={onChange}
                className={`${
                    checked ? 'bg-brand-primary' : 'bg-grey-medium'
                } relative inline-flex items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-lightest`}
                style={{ width: '30px', height: '18px' }}
            >
                <span
                    className={`inline-block w-3 h-3 transform bg-brand-white rounded-full transition-transform`}
                    style={{ transform: checked ? 'translateX(15px)' : 'translateX(3px)' }}
                />
            </Switch>
            <Switch.Label className="ml-2 text-sm">{label}</Switch.Label>
        </Switch.Group>
    )
}
